import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import DatePicker from "react-datepicker";
import { ReactComponent as CalendarIcon } from "../../../assets/Images/CalendarIcon.svg";
import { ReactComponent as RefreshIcon } from "../../../assets/icons/refresh.svg";
import BaseButton from "../Common/Buttons/BaseButton";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";
import { dashboardStyles } from "../../../assets/MUIStyles/dashboard";

const addDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

const Heading = ({
  filterState,
  setFilterState,
  resetFilters,
  applyFilters,
  refreshLoading,
}) => {
  const { selectedprojectId, dateRange } = filterState;
  const [startingDate, endingDate] = dateRange;

  const handleDateChange = (updated) => {
    setFilterState((prev) => ({
      ...prev,
      dateRange: updated,
    }));
  };

  return (
    <Box className="flex-between-only">
      <Typography className="font-20-grey">Dashboard</Typography>
      <Box
        sx={{
          height: 36,
          gap: 1,
        }}
      >
        <Box sx={dashboardStyles.calendarContainer}>
          <DatePicker
            dateFormat="dd/MM/yyyy"
            selectsRange
            maxDate={addDays(new Date(), 0)}
            startDate={startingDate}
            endDate={endingDate}
            onChange={handleDateChange}
            placeholderText="From date - To date"
            className="custom-date-input"
          />
          <CalendarIcon className="calendar-icon" />
        </Box>
        <BaseButton
          variant="contained"
          title="Apply"
          disabled={
            refreshLoading ||
            (!selectedprojectId && (!startingDate || !endingDate))
          }
          handleClick={() => applyFilters(false)}
        />
        <BaseButton
          variant="outlined"
          title="Reset"
          disabled={refreshLoading}
          handleClick={resetFilters}
        />

        <IconButton
          title="Refresh"
          onClick={() => applyFilters(true)}
          sx={{
            ...commonStyles.refreshButtonStyle,
            ...dashboardStyles.refreshAnimation(refreshLoading),
          }}
          disabled={refreshLoading}
        >
          <RefreshIcon className="refresh-icon" height={14} width={14} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Heading;
